import Model, { attr } from '@ember-data/model';
import { isEmpty } from '@ember/utils';
import { computed, getProperties, get } from '@ember/object';
import { gt } from '@ember/object/computed';

export default Model.extend({
  name: attr('string'),
  nameLowerCase: computed('name', function () {
    return (this.name || '').toLowerCase();
  }),
  address1: attr('string'),
  address2: attr('string'),
  city: attr('string'),
  state: attr('string'),
  cityAndState: computed('city', 'state', function () {
    let { city, state } = getProperties(this, 'city', 'state');
    if (isEmpty(city) && isEmpty(state)) {
      return null;
    } else if (!isEmpty(city) && !isEmpty(state)) {
      return `${city}, ${state}`;
    } else if (!isEmpty(city)) {
      return city;
    } else {
      return state;
    }
  }),
  zip: attr('string'),
  country: attr('string'),
  phones: attr(),
  hasPhones: gt('phones.data.length', 0),
  emails: attr(),
  hasEmails: gt('emails.data.length', 0),
  custom: attr(),
});
